import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=21828655"
import script from "./loginForm.vue?vue&type=script&lang=ts"
export * from "./loginForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports